interface AvailableRoom {
  id: string;
  room_number: string;
  room_type: string;
  floor: number;
  capacity: number;
  status: string;
}

interface AvailabilityResponse {
  success: boolean;
  check_in: string;
  check_out: string;
  filters?: {
    room_type: string | null;
    guests: number;
  };
  available_rooms: AvailableRoom[];
  total_available: number;
  error?: string;
}

export async function checkAvailability(
  checkIn: string,
  checkOut: string,
  guests: number
): Promise<AvailabilityResponse> {
  try {
    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://dynwxmohhmfipguwzcgb.supabase.co';
    const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR5bnd4bW9oaG1maXBndXd6Y2diIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI0NzYwMzcsImV4cCI6MjA4ODA1MjAzN30.q3JmpdmPpwcTSrD-ePQrgmGplmRuktFHDCQj4XVTtOE';
    const apiUrl = `${supabaseUrl}/functions/v1/check-availability?check_in=${checkIn}&check_out=${checkOut}&guests=${guests}`;

    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${supabaseAnonKey}`,
        'apikey': supabaseAnonKey,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('API error response:', response.status, errorText);
      throw new Error(`API error: ${response.status} ${response.statusText}`);
    }

    const data: AvailabilityResponse = await response.json();
    console.log('API response data:', data);

    if (!data.success) {
      throw new Error(data.error || 'Failed to check availability');
    }

    return data;
  } catch (error) {
    console.error('Error checking availability:', error);
    if (error instanceof Error) {
      console.error('Error message:', error.message);
      console.error('Error stack:', error.stack);
    }
    throw error;
  }
}

export function getRoomTypeMapping(roomType: string): string {
  const mapping: Record<string, string> = {
    'Matrimoniale': 'double',
    'Triple': 'triple',
    'Quadruple': 'quadruple',
    'Family': 'family',
  };

  return mapping[roomType] || roomType.toLowerCase();
}
